import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api, formatDate, formatDateTime } from "@/lib/api";
import { sectionName } from "@/lib/sections";

const StatusPill = ({ status, id, at }) => (
  <span data-testid={`admin-article-status-${id}`} className={`font-ui text-[11px] uppercase tracking-wider px-2 py-0.5 ${status === "published" ? "bg-[#E7F0E9] text-[#1F5130]" : status === "scheduled" ? "bg-[#E8EEF6] text-[#1A365D]" : "bg-[#EFEFEC] text-[var(--ink-2)]"}`}>
    {status === "scheduled" ? `Scheduled · ${formatDateTime(at)}` : status}
  </span>
);

export default function AdminDashboard() {
  const [articles, setArticles] = useState(null);
  useEffect(() => { api.get("/admin/articles").then((r) => setArticles(r.data)); }, []);

  return (
    <div>
      <div className="flex items-end justify-between">
        <div>
          <p className="meta">Manage</p>
          <h1 className="font-display text-4xl font-bold mt-1">Articles</h1>
        </div>
        <Link to="/admin/new" className="inline-flex items-center gap-2 bg-[var(--ink)] text-white font-ui text-sm px-4 py-2.5 hover:bg-[var(--accent)] transition-colors" data-testid="admin-new-article-button">
          <Plus size={16} /> New article
        </Link>
      </div>
      <div className="mt-8 bg-white border border-[var(--rule)]" data-testid="admin-article-list">
        {!articles && <p className="p-6 meta">Loading</p>}
        {articles?.length === 0 && <p className="p-6 italic text-[var(--ink-3)]">No articles yet.</p>}
        {articles?.map((a) => (
          <Link key={a.id} to={`/admin/edit/${a.id}`} className="flex flex-wrap items-center gap-4 px-6 py-5 border-b border-[var(--rule)] last:border-b-0 hover:bg-[#FAFAF8] transition-colors" data-testid={`admin-article-row-${a.id}`}>
            <div className="flex-1 min-w-[240px]">
              <p className="font-display text-xl font-semibold">{a.headline}</p>
              <p className="mt-1 meta !tracking-[0.1em]">
                {sectionName(a.section)}{a.interview ? " · In their words" : ""} · Updated {formatDate(a.updated_at)}
              </p>
            </div>
            <StatusPill status={a.status} id={a.id} at={a.published_at} />
          </Link>
        ))}
      </div>
    </div>
  );
}
